<div>
    <div class="login-container">
        <mat-card class="text-center login-card">
            <img [src]="logo" class="login-main-logo">
            {{headMessage}}
        </mat-card>
        <div *ngIf="displayPromo">
            <mat-card *ngFor="let promo of promotional">
                <mat-card-header>
                    <div class="btnclose">
                        <button mat-icon-button (click)="onClose()">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </div>
                </mat-card-header>
                <img mat-card-image [src]="promo.img" alt="">
                <mat-card-content>
                    <p>{{promo.text}}</p>
                    <a [href]="[promo.link]" [style.color]="color">{{promo.linkText}}</a>
                </mat-card-content>
            </mat-card>
        </div>
        <mat-accordion>
            <ng-container *ngFor="let tab of accordionTabs; let i = index;">
                <mat-expansion-panel *ngIf="tab.active" [expanded]="accordionTabs?.length === 1"
                    [hideToggle]="tab.direct">
                    <mat-expansion-panel-header (click)="tab.direct ? tab.directFunction() : null">
                        <mat-panel-title>{{tab.title}}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="tab-content" *ngIf="!tab.direct">
                        <img *ngIf="tab.image" class="tab-image" [src]="tab.image">
                        <form [formGroup]="tab.validators"
                            *ngIf="tab.type !== 3 || (tab.type === 3 && btnSAML && !btnOnlySAML) || (tab.type === 3 && !btnSAML && btnOnlySAML) || (tab.type === 3 && !btnSAML && !btnOnlySAML)">
                            <mat-form-field *ngFor="let field of tab.fields; let a = index" class="full-width"
                                appearance="outline">
                                <input [readonly]="field.readonly" [name]="field.id" [id]="field.id"
                                    [ngClass]="{'pass-input': field.type == 'password'}"
                                    [type]="field.type == 'password' ? (hide ? 'password' : 'text') : field.type"
                                    matInput placeholder="{{field.label}}" formControlName="{{field.id}}"
                                    (keyup.enter)="onEnter($event, tab, i)"
                                    [autocomplete]="autocomplete ? field.id : field.id == 'password' ? 'new-password' : 'off'">
                                <i class="material-icons pointer" *ngIf="field.type == 'password'" matSuffix
                                    (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</i>
                                <mat-error *ngIf="getErrorMessage(field.id, i).length">{{getErrorMessage(field.id,
                                    i)[0]}}</mat-error>
                            </mat-form-field>
                        </form>
                        <button mat-flat-button class="w-100" [color]="color ? null : 'primary'"
                            [style.background-color]="color" [style.color]="textColor" (click)="onSubmit(i)"
                            [disabled]="!tab.validators.valid || btnDisabled"
                            *ngIf="tab.type !== 3 || (tab.type === 3 && btnSAML && !btnOnlySAML) || (tab.type === 3 && !btnSAML && btnOnlySAML) || (tab.type === 3 && !btnSAML && !btnOnlySAML)">{{tab.submitBtnLabel}}</button>
                        <button mat-flat-button class="saml" [color]="color ? null : 'primary'"
                            [style.background-color]="color" [style.color]="textColor" (click)="redirectSAML()"
                            *ngIf="tab.type === 3 && btnSAML">{{tab.samlBtnLabel}}</button>
                        <div class="col-12 text-center mt-3" *ngIf="tab.passwordRecover">
                            <a class="px-2 link-recover-pass" (click)="recoverPass(i)" [style.color]="color">
                                {{tab.recoverBtnLabel}}
                            </a>
                        </div>
                    </div>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>

    </div>

</div>